import {
  Accordion,
  AccordionSummary,
  Icon,
  AccordionDetails,
} from "@material-ui/core";
import { Backdrop, CircularProgress } from "@material-ui/core";
import ReferenceLink from "../components/ReferenceLink";
import { makeStyles } from "@material-ui/core";
import OpenSourceDialog from "../components/OpenSourceDialog";
import { useContext, useEffect } from "react";
import { AppContext } from "../AppContext";
import PrivacyLink from "../components/PrivacyLink";

const useStyles = makeStyles((theme) => ({
  main: {
    alignSelf: "center",
    width: "100%",
    maxWidth: "600px",
    padding: "15px",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "200",
    marginBottom: "30px",
    marginTop: "20px",
  },
  summary: {
    color: theme.palette.primary.main,
    fontStyle: "italic",
    "& > div": {
      justifyContent: "center",
    },
  },
  details: {
    wordBreak: "break-word",
  },
}));

const Info = () => {
  const classes = useStyles();
  const { info, setInfo } = useContext(AppContext);

  useEffect(() => {
    const fetchInfo = async () => {
      if (info) return;

      const res = await fetch(
        "https://api-sinaloa-covid-app.netlify.app/info.json"
      );
      let data = await res.json();
      setInfo(data);
      console.log(data);
    };
    fetchInfo();
  }, [info, setInfo]);

  return (
    <>
      {info ? (
        <div className={classes.main}>
          <p className={classes.title}>Preguntas</p>
          {info.faqs.map(({ question, answer }, idx) => (
            <Accordion key={idx}>
              <AccordionSummary
                expandIcon={<Icon>expand_more</Icon>}
                className={classes.summary}
              >
                <p>{question}</p>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <p>{answer}</p>
              </AccordionDetails>
            </Accordion>
          ))}
          <p className={classes.title}>Fuentes</p>
          {info.fonts.map((font, idx) => (
            <ReferenceLink key={idx} {...font} />
          ))}
          <OpenSourceDialog openSources={info.openSources} />
          <PrivacyLink />
        </div>
      ) : (
        <Backdrop open={true} className={classes.high}>
          <CircularProgress color="primary" className={classes.high} />
        </Backdrop>
      )}
    </>
  );
};

export default Info;
